/* eslint-disable dot-notation */
/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
import {
  getScenarioEstimations,
  getScenarioEstimationsByDate,
  getScenarioEstimationsDaily,
} from "lib/requests/scenarios";
import { nFormatter } from "lib/utils";
import { roiNumerator } from "lib/roi/strategies";
import _ from "lodash";
import * as XLSX from "xlsx";

export const exploreByCategories = [
  { label: "Promotion Category", value: "promotions" },
  { label: "Brand", value: "brands" },
  { label: "Retailer", value: "retailers" },
  { label: "Product", value: "products" },
];

export const promotionsLegendCategories = [
  {
    id: 0,
    label: "Value Destroyer",
    background: "rgba(239, 106, 94, 0.5)",
    borderColor: "rgba(239, 106, 94, 1)",
  },
  {
    id: 1,
    label: "Volume Driver",
    background: "rgba(255, 182, 154, 0.5)",
    borderColor: "rgba(255, 182, 154, 1)",
  },
  {
    id: 2,
    label: "Mid Performer",
    background: "rgba(229, 200, 81, 0.5)",
    borderColor: "rgba(229, 200, 81, 1)",
  },
  {
    id: 3,
    label: "Value Driver",
    background: "rgba(125, 194, 150, 0.5)",
    borderColor: "rgba(125, 194, 150, 1)",
  },
  {
    id: 4,
    label: "Top Performer",
    background: "rgba(34, 197, 94, 0.5)",
    borderColor: "rgba(34, 197, 94, 1)",
  },
];

export const groupColors = {
  "Value Destroyer": "rgba(239, 106, 94, 0.5)",
  "Top Performer": "rgba(95, 223, 131, 0.5)",
  "Value Driver": "rgba(182, 223, 95, 0.5)",
  "Volume Driver": "rgba(239, 162, 94, 0.5)",
  "Mid Performer": "rgba(229, 200, 81, 0.5)",
};

export const groupBorderColors = {
  "Value Destroyer": "rgba(239, 106, 94, 1)",
  "Top Performer": "rgba(95, 223, 131, 1)",
  "Value Driver": "rgba(182, 223, 95, 1)",
  "Volume Driver": "rgba(239, 162, 94, 1)",
  "Mid Performer": "rgba(229, 200, 81, 1)",
};

export const promotionsFetchDataForScenarios = async (
  scenarioId,
  cycleTypeId
) => {
  try {
    let data = null;

    const group_by =
      // cycleTypeId === 4
      //   ? ["product_id", "retailer_id", "area_id", "date"]
      //   :
      ["product_id", "retailer_id", "area_id"];

    const baseFilters = {
      filters: {
        scenario: { id: scenarioId },
        group_by,
        sum: ["units", "units_in", "margin", "sales", "retailer_margin"],
        avg_weight_by_units: ["price"],
        avg_weight_by_units_in: ["price_in", "price_in_wo_taxes"],
      },
    };

    if (cycleTypeId === 1 || cycleTypeId === 2) {
      data = await getScenarioEstimations(baseFilters);
    } else if (cycleTypeId === 3) {
      data = await getScenarioEstimationsByDate(baseFilters);
    } else if (cycleTypeId === 4) {
      data = await getScenarioEstimationsDaily(baseFilters);
    }
    return data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(`Error fetching scenario ${scenarioId}:`, error);
    return null;
  }
};

// export const promotionsFetchDailyDataForScenarios = async (
//   scenarioId,
//   cycleTypeId
// ) => {
//   try {
//     let data = null;

//     const baseFilters = {
//       filters: {
//         scenario: { id: scenarioId },
//         group_by: ["product_id", "retailer_id", "area_id", "date"],
//         sum: ["units", "units_in", "margin", "sales", "retailer_margin"],
//         avg_weight_by_units: ["price"],
//         avg_weight_by_units_in: ["price_in", "price_in_wo_taxes"],
//       },
//     };

//     if (cycleTypeId === 1 || cycleTypeId === 2) {
//       data = await getScenarioEstimations(baseFilters);
//     } else if (cycleTypeId === 3) {
//       data = await getScenarioEstimationsByDate(baseFilters);
//     } else if (cycleTypeId === 4) {
//       data = await getScenarioEstimationsDaily(baseFilters);
//     }
//     return { [scenarioId]: data };
//   } catch (error) {
//     // eslint-disable-next-line no-console
//     console.error(`Error fetching scenario ${scenarioId}:`, error);
//     return null;
//   }
// };

export const aggregateScenarioEstimationsByProductRetailerArea = (
  estimationsDailyGrouped
) => {
  return new Map(
    Object.values(estimationsDailyGrouped).map((groupedEstimations) => {
      const product_id = _.find(groupedEstimations, "product_id")?.product_id;
      const retailer_id = _.find(groupedEstimations, "retailer_id")
        ?.retailer_id;
      const area_id = _.find(groupedEstimations, "area_id")?.area_id;
      const sum_units = _.sumBy(groupedEstimations, "sum_units");
      const sum_units_in = _.sumBy(groupedEstimations, "sum_units_in");
      const sum_sales = _.sumBy(groupedEstimations, "sum_sales");
      const sum_margin = _.sumBy(groupedEstimations, "sum_margin");
      const sum_retailer_margin = _.sumBy(
        groupedEstimations,
        "sum_retailer_margin"
      );
      const avg_weight_by_units_price = _.sumBy(
        groupedEstimations,
        (item) => (item.avg_weight_by_units_price * item.sum_units) / sum_units
      );
      const avg_weight_by_units_in_price_in = _.sumBy(
        groupedEstimations,
        (item) =>
          (item.avg_weight_by_units_in_price_in * item.sum_units_in) /
          sum_units_in
      );
      const avg_weight_by_units_in_price_in_wo_taxes = _.sumBy(
        groupedEstimations,
        (item) =>
          (item.avg_weight_by_units_in_price_in_wo_taxes * item.sum_units_in) /
          sum_units_in
      );
      return [
        `${product_id}-${retailer_id}-${area_id}`,
        {
          product_id,
          retailer_id,
          area_id,
          sum_units,
          sum_units_in,
          sum_margin,
          sum_retailer_margin,
          sum_sales,
          avg_weight_by_units_price,
          avg_weight_by_units_in_price_in,
          avg_weight_by_units_in_price_in_wo_taxes,
        },
      ];
    })
  );
};

export const formatPromotions = (
  scenarioFilteredPromotions,
  refScenarioFilteredPromotions,
  newInvestmentCalculation = false,
  roiStrategy = "standard"
) => {
  const mappedPromos = Object.keys(scenarioFilteredPromotions).map((key) => {
    const estimation = scenarioFilteredPromotions[key];
    const refEstimation = refScenarioFilteredPromotions[key];

    // Calcula lift de unidades (%)
    const lift =
      estimation.sum_units && refEstimation.sum_units
        ? ((estimation.sum_units - refEstimation.sum_units) /
            refEstimation.sum_units) *
          100
        : 0;

    // Calcula ROI
    const investment = newInvestmentCalculation
      ? (refEstimation.avg_weight_by_units_in_price_in_wo_taxes -
          estimation.avg_weight_by_units_in_price_in_wo_taxes) *
        estimation.sum_units_in
      : (refEstimation.avg_weight_by_units_in_price_in -
          estimation.avg_weight_by_units_in_price_in) *
        estimation.sum_units_in;
    const numerator = roiNumerator(roiStrategy, {
      marginEsc: estimation.sum_margin,
      marginRef: refEstimation.sum_margin,
      unitsEsc: estimation.sum_units,
      unitsRef: refEstimation.sum_units,
    });
    const roi = investment !== 0 ? (numerator / investment) * 100 : 0;

    // Guardamos las unidades para normalizar después
    return {
      id: key,
      ...estimation,
      roi,
      lift,
      reference: refEstimation,
    };
  });

  const unitsArray = mappedPromos.map((p) => p.sum_units);
  const maxUnits = Math.max(...unitsArray);
  const minUnits = Math.min(...unitsArray);

  const normalize = (units) => {
    if (maxUnits === minUnits) return 20; // valor medio si todos son iguales
    return 10 + ((units - minUnits) * (50 - 10)) / (maxUnits - minUnits);
  };

  return (
    mappedPromos.map((promo) => ({
      ...promo,
      size: normalize(promo.sum_units),
    })) || []
  );
};

// export function promotionsGroupByProductRetailer(map) {
//   // Convierte el Map a un array de objetos
//   const arr = Array.from(map.values());

//   // Agrupa usando reduce
//   const grouped = arr.reduce((acc, item) => {
//     const key = `${item.product_id}-${item.retailer_id}`;
//     if (!acc[key]) {
//       acc[key] = {
//         product_id: item.product_id,
//         retailer_id: item.retailer_id,
//         brand_id: item.brand_id,
//         sum_units: 0,
//         sum_margin: 0,
//         sum_sales: 0,
//         sum_units_in: 0,
//         sum_retailer_margin: 0,
//         sum_weighted_price: 0,
//         sum_weighted_price_in: 0,
//         sum_weighted_price_wo_taxes: 0,
//         sum_weighted_price_in_wo_taxes: 0,
//         total_units: 0,
//         total_units_in: 0,
//         avg_weight_by_units_price: 0, // Aquí se calculará el promedio ponderado
//         avg_weight_by_units_in_price_in: 0, // Aquí se calculará el promedio ponderado
//         avg_weight_by_units_price_wo_taxes: 0, // Aquí se calculará el promedio ponderado
//         avg_weight_by_units_in_price_in_wo_taxes: 0, // Aquí se calculará el promedio ponderado
//       };
//     }
//     acc[key].sum_units += item.sum_units || 0;
//     acc[key].sum_units_in += item.sum_units_in || 0;
//     acc[key].sum_margin += item.sum_margin || 0;
//     acc[key].sum_sales += item.sum_sales || 0;
//     acc[key].sum_retailer_margin += item.sum_retailer_margin || 0;
//     acc[key].sum_weighted_price +=
//       (item.avg_weight_by_units_price || 0) * (item.sum_units || 0);
//     acc[key].sum_weighted_price_in +=
//       (item.avg_weight_by_units_in_price_in || 0) * (item.sum_units_in || 0);
//     acc[key].sum_weighted_price_wo_taxes +=
//       (item.avg_weight_by_units_price_wo_taxes || 0) * (item.sum_units || 0);
//     acc[key].sum_weighted_price_in_wo_taxes +=
//       (item.avg_weight_by_units_in_price_in_wo_taxes || 0) *
//       (item.sum_units_in || 0);
//     acc[key].total_units += item.sum_units || 0;
//     acc[key].total_units_in += item.sum_units_in || 0;
//     return acc;
//   }, {});

//   // Calcula los promedios ponderados dentro de cada objeto agrupado
//   Object.values(grouped).forEach((agg) => {
//     agg.avg_weight_by_units_price = agg.total_units
//       ? agg.sum_weighted_price / agg.total_units
//       : 0;
//     agg.avg_weight_by_units_in_price_in = agg.total_units_in
//       ? agg.sum_weighted_price_in / agg.total_units_in
//       : 0;
//     agg.avg_weight_by_units_price_wo_taxes = agg.total_units
//       ? agg.sum_weighted_price_wo_taxes / agg.total_units
//       : 0;
//     agg.avg_weight_by_units_in_price_in_wo_taxes = agg.total_units_in
//       ? agg.sum_weighted_price_in_wo_taxes / agg.total_units_in
//       : 0;
//   });

//   // Devuelve el array de objetos agrupados con los promedios ya calculados
//   return grouped;
// }

export function aggregatePromotionsByProductRetailer(map) {
  // Convierte el Map a un array de objetos
  const arr = Array.from(map.values());

  const estimationsGroupedByProductRetailer = _.groupBy(
    arr,
    (item) => `${item.product_id}-${item.retailer_id}`
  );

  const estimationsAggregatedByProductRetailer = Object.values(
    estimationsGroupedByProductRetailer || []
  ).map((groupedEstimations) => {
    const reference = _.find(groupedEstimations, "reference")?.reference;
    const brand = _.find(groupedEstimations, "brand")?.brand;
    const product = _.find(groupedEstimations, "product")?.product;
    const retailer = _.find(groupedEstimations, "retailer")?.retailer;
    const product_id = _.find(groupedEstimations, "product_id")?.product_id;
    const retailer_id = _.find(groupedEstimations, "retailer_id")?.retailer_id;
    const brand_id = _.find(groupedEstimations, "retailer_id")?.brand_id;
    const sum_units = _.sumBy(groupedEstimations, "sum_units");
    const sum_units_in = _.sumBy(groupedEstimations, "sum_units_in");
    const sum_sales = _.sumBy(groupedEstimations, "sum_sales");
    const sum_margin = _.sumBy(groupedEstimations, "sum_margin");
    const sum_retailer_margin = _.sumBy(
      groupedEstimations,
      "sum_retailer_margin"
    );
    const avg_weight_by_units_price = _.sumBy(
      groupedEstimations,
      (item) => (item.avg_weight_by_units_price * item.sum_units) / sum_units
    );
    const avg_weight_by_units_in_price_in = _.sumBy(
      groupedEstimations,
      (item) =>
        (item.avg_weight_by_units_in_price_in * item.sum_units_in) /
        sum_units_in
    );
    const avg_weight_by_units_in_price_in_wo_taxes = _.sumBy(
      groupedEstimations,
      (item) =>
        (item.avg_weight_by_units_in_price_in_wo_taxes * item.sum_units_in) /
        sum_units_in
    );
    return [
      `${product_id}-${retailer_id}`,
      {
        reference,
        brand,
        product,
        retailer,
        product_id,
        retailer_id,
        brand_id,
        sum_units,
        sum_units_in,
        sum_margin,
        sum_retailer_margin,
        sum_sales,
        avg_weight_by_units_price,
        avg_weight_by_units_in_price_in,
        avg_weight_by_units_in_price_in_wo_taxes,
      },
    ];
  });

  return Object.fromEntries(estimationsAggregatedByProductRetailer);
}

export function getQuartiles(data) {
  // Solo lifts positivos
  const liftPositive = data
    .filter((d) => d.lift > 0)
    .map((d) => d.lift)
    .sort((a, b) => a - b);
  // Solo ROI positivo
  const roiPositive = data
    .filter((d) => d.roi > 0)
    .map((d) => d.roi)
    .sort((a, b) => a - b);

  const liftQ25 = liftPositive.length
    ? liftPositive[Math.floor(liftPositive.length * 0.25)]
    : 0;
  const liftQ75 = liftPositive.length
    ? liftPositive[Math.floor(liftPositive.length * 0.75)]
    : 0;
  const roiQ75 = roiPositive.length
    ? roiPositive[Math.floor(roiPositive.length * 0.75)]
    : 0;

  return { liftQ25, liftQ75, roiQ75 };
}

export function classifyPromo(promo, q) {
  // Top Performer
  if (promo.lift >= q.liftQ75 && promo.roi >= q.roiQ75) {
    return "Top Performer";
  }
  // Value Driver
  if (promo.lift < q.liftQ75 && promo.roi >= q.roiQ75) {
    return "Value Driver";
  }
  // Volume Driver
  if (promo.roi <= 0 && promo.lift >= q.liftQ25) {
    return "Volume Driver";
  }
  // Value Destroyer
  if (promo.roi <= 0 && promo.lift < q.liftQ25) {
    return "Value Destroyer";
  }
  return "Mid Performer";
}

export function groupPromosByCategory(localPromos, localQuartiles) {
  const groups = {
    "Value Destroyer": [],
    "Volume Driver": [],
    "Mid Performer": [],
    "Value Driver": [],
    "Top Performer": [],
  };
  localPromos.forEach((promo) => {
    const cat = classifyPromo(promo, localQuartiles);
    groups[cat].push({
      x: promo.roi,
      y: promo.lift,
      r: promo.size,
      ...promo,
    });
  });
  return groups;
}

export function getColorById(id, alpha = 1) {
  // Usa el algoritmo golden angle para distribuir colores en el círculo cromático
  const goldenAngle = 137.508; // grados
  // Convierte el id a un número (por si acaso es string)
  const n = Number(id);
  // Calcula el ángulo único para este id
  const hue = (n * goldenAngle) % 360;
  // Saturación y luminosidad fijas para buena diferenciación
  const saturation = 50;
  const lightness = 50;
  // Devuelve el color en formato hsla
  return `hsla(${Math.floor(Number(hue))}, ${Number(saturation)}%, ${Number(
    lightness
  )}%, ${Number(alpha)})`;
}

export const getBubbleChartOptions = ({
  minROI,
  maxROI,
  maxLift,
  minLift,
  quartiles,
  maxROIFromDataset,
  minROIFromDataset,
  maxLiftFromDataset,
  minLiftFromDataset,
}) => {
  return {
    responsive: true,
    maintainAspectRatio: false,
    // elements: {
    //   point: {
    //     radius: undefined, // deja que r controle el tamaño
    //     minRadius: 5,
    //     maxRadius: 20,
    //   },
    // },
    animation: {
      duration: 800, // Duración en ms para entrada y salida
      easing: "easeInOutCubic", // Suavidad de la animación
      animateScale: true, // Escala las burbujas al aparecer/desaparecer
      animateRotate: false,
      onComplete: () => {},
      onProgress: () => {},
    },
    legend: {
      display: false,
      position: "bottom",
      labels: {
        usePointStyle: true,
        fontSize: 14,
      },
      // onClick: legendOnClickCallback,
    },
    layout: {
      padding: {
        left: 15,
        right: 15,
        top: 15,
        bottom: 15,
      },
    },
    title: {
      display: false,
    },
    tooltips: {
      enabled: true,
      intersect: true,
      mode: "nearest",
      callbacks: {
        label(tooltipItem, data) {
          const dataset = data.datasets[tooltipItem.datasetIndex];
          const point = dataset.data[tooltipItem.index];
          return [
            `CATEGORY: ${String(dataset.label).toUpperCase()}`,
            `PRODUCT: ${String(point.product.label).toUpperCase()}`,
            `RETAILER: ${String(point.retailer.label).toUpperCase()}`,
            `BRAND: ${String(point.brand.label).toUpperCase()}`,
            `PRICE OUT: $${Math.round(point.avg_weight_by_units_price * 1000) /
              1000}`,
            `SALES OUT: $${nFormatter(Math.round(point.sum_sales))}`,
            `MARGIN: $${nFormatter(Math.round(point.sum_margin))}`,
            `LIFT UNITS: ${Math.round(point.lift * 100) / 100}%`,
            `ROI: ${Math.round(point.roi * 100) / 100}%`,
          ];
        },
      },
    },
    annotation: {
      // Cuadrantes de fondo
      annotations: [
        // Value Destroyer (abajo izquierda)
        {
          type: "box",
          xScaleID: "x-axis-0",
          yScaleID: "y-axis-0",
          // xMin: minROI - Math.abs(maxROI) * 0.1,
          xMin: minROI,
          xMax: 0,
          // yMin: minLift - Math.abs(minLift) * 0.1,
          yMin: minLift,
          yMax: quartiles.liftQ25,
          backgroundColor: "rgba(239, 106, 94, 0.15)",
          borderColor: "rgba(239, 106, 94, 0.5)",
          borderWidth: 1.5,
          label: {
            enabled: true,
            content: "Nombre del cuadrante",
            position: "center", // o "top", "bottom", etc.
            font: {
              size: 16,
              weight: "bold",
            },
            color: "#222",
          },
        },
        // Volume Driver (arriba izquierda)
        {
          type: "box",
          xScaleID: "x-axis-0",
          yScaleID: "y-axis-0",
          // xMin: minROI - Math.abs(maxROI) * 0.1,
          xMin: minROI,
          xMax: 0,
          yMin: quartiles.liftQ25,
          // yMax: maxLift + Math.abs(maxLift) * 0.1,
          yMax: maxLift,
          backgroundColor: "rgba(239, 162, 94, 0.15)",
          borderColor: "rgba(239, 162, 94, 0.5)",
          borderWidth: 1.5,
        },
        // Mid Performer (centro)
        {
          type: "box",
          xScaleID: "x-axis-0",
          yScaleID: "y-axis-0",
          xMin: 0,
          xMax: quartiles.roiQ75,
          // yMin: minLift - Math.abs(minLift) * 0.1,
          yMin: minLift,
          // yMax: maxLift + Math.abs(maxLift) * 0.1,
          yMax: maxLift,
          backgroundColor: "rgba(229, 200, 81, 0.15)",
          borderColor: "rgba(229, 200, 81, 0.5)",
          borderWidth: 1.5,
        },
        // Value Driver (abajo derecha)
        {
          type: "box",
          xScaleID: "x-axis-0",
          yScaleID: "y-axis-0",
          xMin: quartiles.roiQ75,
          // xMax: maxROI + Math.abs(maxROI) * 0.1,
          xMax: maxROI,
          // yMin: minLift - Math.abs(minLift) * 0.1,
          yMin: minLift,
          yMax: quartiles.liftQ75,
          backgroundColor: "rgba(182, 223, 95, 0.15)",
          borderColor: "rgba(182, 223, 95, 1)",
          borderWidth: 1.5,
        },
        // Top Performer (arriba derecha)
        {
          type: "box",
          xScaleID: "x-axis-0",
          yScaleID: "y-axis-0",
          xMin: quartiles.roiQ75,
          // xMax: maxROI + Math.abs(maxROI) * 0.1,
          xMax: maxROI,
          yMin: quartiles.liftQ75,
          // yMax: maxLift + Math.abs(maxLift) * 0.1,
          yMax: maxLift,
          backgroundColor: "rgba(95, 223, 131, 0.15)",
          borderColor: "rgba(95, 223, 131, 0.5)",
          borderWidth: 1.5,
        },
        // {
        //   type: "line",
        //   mode: "vertical",
        //   scaleID: "x-axis-0",
        //   value: 0,
        //   borderColor: "#222",
        //   borderWidth: 2,
        // },
      ],
    },
    scales: {
      xAxes: [
        {
          id: "x-axis-0",
          scaleLabel: {
            display: true,
            labelString: "ROI",
            fontSize: 16,
            fontStyle: "bold",
          },
          ticks: {
            // min: minROIFromDataset - Math.abs(maxROIFromDataset) * 0.2,
            // max: maxROIFromDataset + Math.abs(maxROIFromDataset) * 0.2,
            min: minROIFromDataset,
            max: maxROIFromDataset,
            maxTicksLimit: 2, // Máximo 10 ticks
          },
          gridLines: { color: "#ccc" },
        },
      ],
      yAxes: [
        {
          id: "y-axis-0",
          scaleLabel: {
            display: true,
            labelString: "LIFT %",
            fontSize: 16,
            fontStyle: "bold",
          },
          ticks: {
            // min: minLiftFromDataset - Math.abs(maxLiftFromDataset) * 0.2,
            // max: maxLiftFromDataset + Math.abs(maxLiftFromDataset) * 0.2,
            min: minLiftFromDataset,
            max: maxLiftFromDataset,
            maxTicksLimit: 2, // Máximo 10 ticks
          },
          gridLines: { color: "#ccc" },
        },
      ],
    },
  };
};

export const downloadPromotionsExcel = (
  promotionsTableData,
  scenarioName = ""
) => {
  // Helper function para calcular porcentaje de cambio
  const calculatePercentageChange = (current, reference) => {
    if (!reference || reference === 0) return 0;
    return ((current - reference) / reference) * 100;
  };
  const excelData = Array.from(promotionsTableData)
    // ordenar por product label y retailer label
    .sort((a, b) => {
      const productLabelA = a.product.label;
      const productLabelB = b.product.label;
      if (productLabelA !== productLabelB) {
        return productLabelA.localeCompare(productLabelB);
      }
      const retailerLabelA = a.retailer.label;
      const retailerLabelB = b.retailer.label;
      return retailerLabelA.localeCompare(retailerLabelB);
    })
    // Transforma los datos para el Excel con los headers específicos
    .map((item) => {
      const row = {};

      // Solo agregar campos si existen en los datos
      if (item.date) row["Date"] = item.date;
      if (item.product?.label) row["Product"] = item.product.label;
      if (item.product_id) row["Product id"] = item.product_id;
      if (item.product?.upc) row["Product UPC"] = item.product.upc;
      if (item.retailer?.label) row["Retailer"] = item.retailer.label;
      if (item.retailer_id) row["Retailer id"] = item.retailer_id;
      if (item.area?.label) row["Area"] = item.area.label;
      if (item.area_id) row["Area id"] = item.area_id;
      if (item.line?.label) row["Line"] = item.line.label;
      if (item.category?.label) row["Category"] = item.category.label;

      // Precios
      if (item.avg_weight_by_units_in_price_in) {
        row["Price In ($)"] = item.avg_weight_by_units_in_price_in;
        if (item.reference?.avg_weight_by_units_in_price_in) {
          row["Price In vs Ref (%)"] = calculatePercentageChange(
            item.avg_weight_by_units_in_price_in,
            item.reference.avg_weight_by_units_in_price_in
          );
        }
      }

      if (item.avg_weight_by_units_price) {
        row["Price Out ($)"] = item.avg_weight_by_units_price;
        if (item.reference?.avg_weight_by_units_price) {
          row["Price Out vs Ref (%)"] = calculatePercentageChange(
            item.avg_weight_by_units_price,
            item.reference.avg_weight_by_units_price
          );
        }
      }

      if (
        item.avg_weight_by_units_price_wo_taxes &&
        item.reference?.avg_weight_by_units_price_wo_taxes
      ) {
        row["Price Out Without Taxes vs Ref (%)"] = calculatePercentageChange(
          item.avg_weight_by_units_price_wo_taxes,
          item.reference.avg_weight_by_units_price_wo_taxes
        );
      }

      if (
        item.avg_weight_by_units_in_price_in_wo_taxes &&
        item.reference?.avg_weight_by_units_in_price_in_wo_taxes
      ) {
        row["Price In Without Taxes vs Ref (%)"] = calculatePercentageChange(
          item.avg_weight_by_units_in_price_in_wo_taxes,
          item.reference.avg_weight_by_units_in_price_in_wo_taxes
        );
      }

      if (item.promotional_price)
        row["Price Out ($ Promotional)"] = item.promotional_price;
      if (item.redemption) row["Redemption"] = item.redemption;

      // Unidades
      if (item.sum_units_in) {
        row["Units In (Pieces)"] = item.sum_units_in;
        if (item.reference?.sum_units_in) {
          row["Units In vs Ref (%)"] = calculatePercentageChange(
            item.sum_units_in,
            item.reference.sum_units_in
          );
        }
      }

      if (item.sum_units) {
        row["Units (Pieces)"] = item.sum_units;
        if (item.reference?.sum_units) {
          row["Units vs Ref (%)"] = calculatePercentageChange(
            item.sum_units,
            item.reference.sum_units
          );
        }
      }

      // Margen
      if (item.sum_margin) {
        row["Margin ($)"] = item.sum_margin;
        if (item.reference?.sum_margin) {
          row["Margin vs Ref (%)"] = calculatePercentageChange(
            item.sum_margin,
            item.reference.sum_margin
          );
        }
      }

      if (item.sum_retailer_margin)
        row["Retailer Margin ($)"] = item.sum_retailer_margin;

      // Ventas
      if (item.sum_sales_in) {
        row["Sales In ($)"] = item.sum_sales_in;
        if (item.reference?.sum_sales_in) {
          row["Sales In vs Ref (%)"] = calculatePercentageChange(
            item.sum_sales_in,
            item.reference.sum_sales_in
          );
        }
      }

      if (item.sum_sales) {
        row["Sales ($)"] = item.sum_sales;
        if (item.reference?.sum_sales) {
          row["Sales vs Ref (%)"] = calculatePercentageChange(
            item.sum_sales,
            item.reference.sum_sales
          );
        }
      }

      // Inversión y ROI
      if (item.sum_investment_out)
        row["Investment Out ($)"] = item.sum_investment_out;
      if (item.sum_investment_in)
        row["Investment In ($)"] = item.sum_investment_in;
      if (item.roi) row["ROI"] = item.roi;
      if (item.event) row["Event"] = item.event;
      if (item.label) row["Promotion Category"] = item.label;

      return row;
    });

  // Crear el libro de trabajo
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(excelData);

  // Agregar la hoja al libro
  XLSX.utils.book_append_sheet(workbook, worksheet, "Promotions Data");

  // Generar nombre del archivo con fecha y hora
  const now = new Date();
  const timestamp = now
    .toISOString()
    .replace(/[:.]/g, "-")
    .slice(0, -5);
  const filename = `${scenarioName}_promotions_${timestamp}.xlsx`;

  // Descargar el archivo
  XLSX.writeFile(workbook, filename);
};
